// El tipo de cambio de un movimiento ya viene guardado en el renglón (CargoAbono.tipoDeCambio,
// con default 1) y viaja completo al frontend porque datosPoliza lee los cargos/abonos sin
// .select(). Aquí sólo se decide cómo se muestra: se anexa al concepto del renglón cuando es
// distinto de 1, para no ensuciar los conceptos de todo lo que se opera en pesos.
//
// Se resuelve al pintar y no al guardar, igual que el orden por proyecto: así aplica también a
// las pólizas viejas y a las ya timbradas, sin tocar los ~100 lugares que crean pólizas.
//
// Un tipoDeCambio en null es deliberado: datosPoliza lo pone así cuando agrupa renglones con
// tipos de cambio distintos, porque mostrar uno solo de ellos sería incorrecto.
const conceptoConTipoDeCambio = (concepto, tipoDeCambio) => {
  const texto = concepto || ''
  if (tipoDeCambio === null || tipoDeCambio === undefined) return texto
  const tc = Number(tipoDeCambio)
  if (!isFinite(tc) || tc === 0 || tc === 1) return texto
  return texto + ' (T.C. ' + tc + ')'
}

export default conceptoConTipoDeCambio
